const environment = () => {
    const version = 'v1'
    const reactAppEnv = process.env.REACT_APP_ENV

    const env = reactAppEnv === 'prd' ? '' : '/' + reactAppEnv

    if (reactAppEnv === 'prd') {
        const environments = {
            ENDPOINT_HEALTH_ES: `https://api.registrauto.com.br${env}/detrans/${version}/detrans/es/actuator/health`,
            ENDPOINT_HEALTH_CONTRACTS: `https://api.registrauto.com.br${env}/contratos/actuator/health`,
            ENDPOINT_HEALTH_AGENTS: `https://api.registrauto.com.br${env}/agentes-financeiros/actuator/health`,
            ENDPOINT_HEALTH_INSTITUTIONS: `https://api.registrauto.com.br${env}/instituicoes-financeiras/actuator/health`,
            ENDPOINT_HEALTH_USERS: `https://api.registrauto.com.br${env}/usuarios/actuator/health`,
            ENDPOINT_HEALTH_REPORTS: `https://api.registrauto.com.br${env}/relatorios/actuator/health`,
            WEBSOCKET_CONNECTIONS: `wss://el4x44j2ri.execute-api.sa-east-1.amazonaws.com/production`,
            ENDPOINT_API_AUTH: `https://api.registrauto.com.br${env}/auth/${version}`,
            ENDPOINT_API_USERS: `https://api.registrauto.com.br${env}/usuarios/${version}`,
            ENDPOINT_API_INSTITUTIONS: `https://api.registrauto.com.br${env}/instituicoes-financeiras/${version}`,
            ENDPOINT_API_AGENTS: `https://api.registrauto.com.br${env}/agentes-financeiros/${version}`,
            ENDPOINT_CONTRACTS: `https://api.registrauto.com.br${env}/contratos/${version}`,
            ENDPOINT_CONTRACTS_V2: `https://api.registrauto.com.br${env}/contratos/v2`,
            ENDPOINT_VIACEP: `https://api.registrauto.com.br${env}/cep`,
            ENDPOINT_VIAMUNICIPIO: `https://api.registrauto.com.br${env}/localidades`,
            ENDPOINT_REPORT_CSV: `https://api.registrauto.com.br${env}/relatorios/${version}`,
            ENDPOINT_API_TAXAS: `https://api.registrauto.com.br${env}/taxas/${version}/taxas`,
            ENDPOINT_API_OPERACOES_TAXAS: `https://api.registrauto.com.br${env}/taxas/${version}/operacoes/taxas`,
            ENDPOINT_API_TABELA_TAXAS: `https://api.registrauto.com.br${env}/taxas/${version}/operacoes/tabelas-taxas`,
            ENDPOINT_API_DETRANS: `https://api.registrauto.com.br${env}/detrans/${version}`,
            CAPTCHA_SITE_KEY: `6LeJt3kkAAAAAIBXthlxjj-k5DX0Wa2oZOTexRAD`,
            CONTRACT_CANCELLATION: true,
            SIGNATURE_ATTACHMENTS: false
        }
        return environments
    } else if (reactAppEnv === 'dev') {
        const environments = {
            ENDPOINT_HEALTH_ES: `https://r3z9uojngf.execute-api.us-east-1.amazonaws.com${env}/${version}/detrans/es/actuator/health`,
            ENDPOINT_HEALTH_CONTRACTS: `https://f6ker6iyfg.execute-api.us-east-1.amazonaws.com${env}/actuator/health`,
            ENDPOINT_HEALTH_AGENTS: `https://4p40lrutqc.execute-api.us-east-1.amazonaws.com${env}/actuator/health`,
            ENDPOINT_HEALTH_INSTITUTIONS: `https://r84wn0jrjf.execute-api.us-east-1.amazonaws.com${env}/actuator/health`,
            ENDPOINT_HEALTH_USERS: `https://e9jqvn8ohi.execute-api.us-east-1.amazonaws.com${env}/actuator/health`,
            ENDPOINT_HEALTH_REPORTS: `https://x21ch1y4x4.execute-api.us-east-1.amazonaws.com${env}/actuator/health`,
            WEBSOCKET_CONNECTIONS: `wss://d5f6itmpca.execute-api.us-east-1.amazonaws.com/dev`,
            ENDPOINT_API_AUTH: `https://6xo3e6fdbf.execute-api.us-east-1.amazonaws.com${env}/${version}`,
            ENDPOINT_API_USERS: `https://e9jqvn8ohi.execute-api.us-east-1.amazonaws.com${env}/${version}`,
            //ENDPOINT_API_USERS: `http://localhost:8013/v1`,
            ENDPOINT_API_INSTITUTIONS: `https://r84wn0jrjf.execute-api.us-east-1.amazonaws.com${env}/${version}`,
            ENDPOINT_API_AGENTS: `https://4p40lrutqc.execute-api.us-east-1.amazonaws.com${env}/${version}`,
            ENDPOINT_CONTRACTS: `https://f6ker6iyfg.execute-api.us-east-1.amazonaws.com${env}/${version}`,
            ENDPOINT_CONTRACTS_V2: `https://f6ker6iyfg.execute-api.us-east-1.amazonaws.com${env}/v2`,
            ENDPOINT_API_TAXAS: `https://1xxmvzz1qb.execute-api.us-east-1.amazonaws.com${env}/${version}/taxas`,
            ENDPOINT_API_OPERACOES_TAXAS: `https://1xxmvzz1qb.execute-api.us-east-1.amazonaws.com${env}/${version}/operacoes/taxas`,
            ENDPOINT_API_TABELA_TAXAS: `https://1xxmvzz1qb.execute-api.us-east-1.amazonaws.com${env}/${version}/operacoes/tabelas-taxas`,
            ENDPOINT_VIACEP: `https://a1nvgexd48.execute-api.us-east-1.amazonaws.com${env}`,
            ENDPOINT_VIAMUNICIPIO: `https://icy8pfecs0.execute-api.us-east-1.amazonaws.com${env}`,
            ENDPOINT_REPORT_CSV: `https://x21ch1y4x4.execute-api.us-east-1.amazonaws.com${env}/${version}`,
            CAPTCHA_SITE_KEY: `6Lcz-k0kAAAAABWD63m60tUV1BEIiLuYul-cwg7-`,
            ENDPOINT_API_DETRANS: `https://r3z9uojngf.execute-api.us-east-1.amazonaws.com${env}/${version}`,
            CONTRACT_CANCELLATION: true,
            SIGNATURE_ATTACHMENTS: true
        }
        return environments
    } else {
        // hml
        const environments = {
            ENDPOINT_HEALTH_ES: `https://api2.registrauto.com.br${env}/detrans/${version}/detrans/es/actuator/health`,
            ENDPOINT_HEALTH_CONTRACTS: `https://api2.registrauto.com.br${env}/contratos/actuator/health`,
            ENDPOINT_HEALTH_AGENTS: `https://api2.registrauto.com.br${env}/agentes-financeiros/actuator/health`,
            ENDPOINT_HEALTH_INSTITUTIONS: `https://api2.registrauto.com.br${env}/instituicoes-financeiras/actuator/health`,
            ENDPOINT_HEALTH_USERS: `https://api2.registrauto.com.br${env}/usuarios/actuator/health`,
            ENDPOINT_HEALTH_REPORTS: `https://api2.registrauto.com.br${env}/relatorios/actuator/health`,
            WEBSOCKET_CONNECTIONS: `wss://xcyti1ma17.execute-api.us-east-1.amazonaws.com/hml`,
            ENDPOINT_API_AUTH: `https://api2.registrauto.com.br${env}/auth/${version}`,
            ENDPOINT_API_USERS: `https://api2.registrauto.com.br${env}/usuarios/${version}`,
            ENDPOINT_API_INSTITUTIONS: `https://api2.registrauto.com.br${env}/instituicoes-financeiras/${version}`,
            ENDPOINT_API_AGENTS: `https://api2.registrauto.com.br${env}/agentes-financeiros/${version}`,
            ENDPOINT_API_TAXAS: `https://api2.registrauto.com.br${env}/taxas/${version}/taxas`,
            ENDPOINT_API_OPERACOES_TAXAS: `https://api2.registrauto.com.br${env}/taxas/${version}/operacoes/taxas`,
            ENDPOINT_API_TABELA_TAXAS: `https://api2.registrauto.com.br${env}/taxas/${version}/operacoes/tabelas-taxas`,
            ENDPOINT_CONTRACTS: `https://api2.registrauto.com.br${env}/contratos/${version}`,
            ENDPOINT_CONTRACTS_V2: `https://api2.registrauto.com.br${env}/contratos/v2`,
            ENDPOINT_VIACEP: `https://api2.registrauto.com.br${env}/cep`,
            ENDPOINT_VIAMUNICIPIO: `https://api2.registrauto.com.br${env}/localidades`,
            ENDPOINT_REPORT_CSV: `https://api2.registrauto.com.br${env}/relatorios/${version}`,
            ENDPOINT_API_DETRANS: `https://api2.registrauto.com.br${env}/detrans/${version}`,
            CAPTCHA_SITE_KEY: `6Lcz-k0kAAAAABWD63m60tUV1BEIiLuYul-cwg7-`,
            CONTRACT_CANCELLATION: true,
            SIGNATURE_ATTACHMENTS: true
        }
        return environments
    }
}

export const environments = environment()
